const warenart = [
	"handgemachte Ware",
	"scheibengedreht",
	"Terra_sigillata",
	"Terra_nigra",
	"Feinware_mit_Glanztonueberzug",
	"glasierte_Keramik",
	"Gebrauchs-/Grobkeramik",
	"Amphoren",
	"unglasierte_Irdenware_(gedreht)",
	"glasierte_Irdenware_(gedreht)",
	"Steinzeug",
	"Fayence",
	"Porzellan",
	"Steingut",
	"Ofenkeramik",
	"Baukeramik",
	"Sonderkeramik"
]

export default warenart;
